import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttention = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 512 512",
	xmlSpace: "preserve",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "st0",
			d: "M256,34.297L0,477.703h512L256,34.297z M83.137,429.703L256,130.297l172.861,299.406H83.137z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			fill: "currentColor",
			className: "st0",
			points: "243.264,338.984 268.734,338.984 276.734,228.984 235.264,228.984  "
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			className: "st0",
			d: "M256,358.984c-11.394,0-20.633,9.236-20.633,20.63c0,11.394,9.238,20.631,20.633,20.631 c11.392,0,20.629-9.237,20.629-20.631C276.629,368.22,267.392,358.984,256,358.984z"
		})
	] })]
});
export default SvgAttention;
